module.exports = __webpack_public_path__ + "media/images/talent/lp/profile01-7e5e9d8e2bb02b93bc8f62be09b3da9a.png";